import { ERROR_TEXT } from 'config'

import type { RegisterOptions } from 'react-hook-form'

function getErrorMessage(key: string, value: unknown): string {
  if (typeof value === 'string') {
    return value
  }
  if (ERROR_TEXT[key]) {
    return ERROR_TEXT[key].replace('$0', value)
  }
  return `${key}: ${value}`
}

/**
 * @param {object} validations react-hook-form validations
 * @example
 * applyErrorMsg({ maxLength: 100 })
 * // => { maxLength: { value: 100, message: '100文字以内で入力してください' }}
 */
export default function applyErrorMsg(
  validations?: RegisterOptions,
): RegisterOptions {
  if (!validations) return {}
  return Object.entries(validations).reduce((result, [key, value]) => {
    if (
      typeof value === 'object' ||
      typeof value === 'function' ||
      typeof value === 'string'
    ) {
      result[key] = value
    } else {
      result[key] = {
        value,
        message: getErrorMessage(key, value),
      }
    }
    return result
  }, {})
}
